import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ObjectUtils } from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storeDataSubjects: Map<string, BehaviorSubject<any>> = new Map();

  public init(): void {
    const skeys = Object.keys(localStorage);

    skeys.forEach(k => {
      const data = ObjectUtils.stringToObject(localStorage[k]);
      if (data) {
        this.storeDataSubjects.set(k, new BehaviorSubject<any>(data));
      }
    });
  }

  public watch(key: string): Observable<any> | null {
    if (!this.storeDataSubjects.has(key)) {
      this.storeDataSubjects.set(key, new BehaviorSubject<any>(null));
    }
    let item: any = localStorage.getItem(key);
    const storeDataKey = this.storeDataSubjects.get(key);
    if (item == 'undefined') {
      item = undefined;
    } else {
      item = ObjectUtils.stringToObject(item);
    }

    if (storeDataKey) {
      storeDataKey.next(item);
    }
    return storeDataKey ? storeDataKey.asObservable() : null;
  }

  public set(key: string, value: any): void {
    const val = JSON.stringify(value);
    localStorage.setItem(key, val);
    const storeDataKey = this.storeDataSubjects.get(key);
    if (!this.storeDataSubjects.has(key) || !storeDataKey) {
      this.storeDataSubjects.set(key, new BehaviorSubject<any>(val));
    } else {
      storeDataKey.next(value);
    }
  }

  public get<T>(key: string): T | undefined {
    const valKey = localStorage.getItem(key);
    return valKey ? (ObjectUtils.stringToObject(valKey) as T) : undefined;
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
    const storeDataKey = this.storeDataSubjects.get(key);
    if (!this.storeDataSubjects.has(key) || !storeDataKey) {
      this.storeDataSubjects.set(key, new BehaviorSubject<any>(null));
    } else {
      storeDataKey.next(null);
    }
  }

  public getKeyList(search: string): string[] {
    const arr = Array.from(this.storeDataSubjects.keys());
    return arr.filter(x => x.includes(search));
  }

  public clearAll(): void {
    localStorage.clear();
    sessionStorage.clear();
  }
}
